import { setActiveDashboard, setBusiness } from "@/redux/slices/user.slice";
import { clearHistory } from "@/redux/slices/dashboardV2.slice";
import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { api, endpoint } from "@/api";
import { userRole } from "@/constant/userRole";
import { flare } from "@flareapp/js";

function HomeSelect({ setIsLoading, className }) {
  const { userDetails, activeDashboard, business } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const location = useLocation();

  //   states
  const [businesses, setBusinesses] = useState([]);
  const [dashboardList, setDashboardList] = useState([]);

  // effects

  useEffect(() => {
    getBusiness();
  }, []);

  useEffect(() => {
    if (location.pathname === "/") {
      getDashboardList();
    }
  }, [location.pathname, business]);

  // call api
  const getBusiness = async () => {
    setIsLoading(true);
    try {
      const data = await api.get(endpoint.business);
      setBusinesses(data?.data);
      if (Array.isArray(data?.data) && data.data.length === 1) {
        dispatch(setBusiness([data.data[0]._id]));
      } else if (Array.isArray(data?.data) && data.data.length === 0) {
        dispatch(setBusiness([]));
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setIsLoading(false);
  };

  const getDashboardList = async () => {
    setIsLoading(true);
    try {
      const { results } = await api.get(endpoint.dashboard_list, {
        params: { business: JSON.stringify(business), limit: 10000 },
      });
      setDashboardList(results || []);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setIsLoading(false);
  };

  //   handler

  const changeDashboardHandler = (value) => {
    dispatch(clearHistory());
    dispatch(setActiveDashboard(value));
  };
  const onChangeBusiness = (value) => {
    dispatch(setBusiness(value));
  };

  return (
    <div className={`az-header-center ${className}`}>
      <div className="row mr-0">
        <>
          <div className="col-md-6 col-lg-4 col-12 pt-2">
            <Select
              style={{ width: "100%" }}
              showSearch={{
                filterOption: (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase()),
              }}
              mode={userDetails?.role === userRole.superAdmin ? "multiple" : ""}
              name="business"
              maxTagCount="responsive"
              // maxTagTextLength={20}
              value={business}
              onChange={onChangeBusiness}
              placeholder="All Businesses"
              disabled={businesses?.length === 1}
              options={[
                ...(businesses?.map((item) => ({
                  label: `${item.name} (${item.id})`,
                  value: item._id,
                })) || []),
              ]}
              required
            />
          </div>

          <div className="col-md-6 col-lg-4 col-12 pt-2">
            <Select
              style={{ width: "100%" }}
              showSearch={{
                filterOption: (input, option) => (option?.searchLabel ?? "").toLowerCase().includes(input.toLowerCase()),
              }}
              value={dashboardList?.some((item) => item._id === activeDashboard) ? activeDashboard : activeDashboard !== "" ? undefined : ""}
              onChange={changeDashboardHandler}
              placeholder="Select a Dashboard"
              options={[
                { value: "", label: "Main Dashboard" },
                ...(dashboardList?.map((item) => ({
                  label: (
                    <div>
                      <span className="text-capitalize text-muted">[{item.type || "Tile"}]</span> {item.name}
                    </div>
                  ),
                  searchLabel: `${item.type || "Tile"} - ${item.name}`,
                  value: item._id,
                })) || []),
              ]}
            />
          </div>
        </>
      </div>
    </div>
  );
}

export default HomeSelect;

HomeSelect.propTypes = {
  setIsLoading: PropTypes.func.isRequired,
  className: PropTypes.string,
};
